export const HSE_MODULE_KEYS = [
  "tiltak",
  "events",
  "documents",
  "competency",
  "evaluation",
  "risk",
  "sja",
  "goals",
];

export const HSE_REVIEW_CADENCE_MONTHS = [3, 6, 12];

const emptySettings = {
  modules: {
    tiltak: true,
    events: true,
    documents: true,
    competency: true,
    evaluation: true,
    risk: true,
    sja: true,
    goals: true,
  },
  responsible_user_id: null,
  other_manager_user_id: null,
  review_cadence_months: 12,
  default_tiltak_due_days: 14,
  tiltak_require_approval: false,
};

function asBool(value, fallback = true) {
  if (value === true || value === false) return value;
  if (value === "true") return true;
  if (value === "false") return false;
  return fallback;
}

export function normalizeHseReviewCadence(value, fallback = 12) {
  const n = Number(value);
  return HSE_REVIEW_CADENCE_MONTHS.includes(n) ? n : fallback;
}

export function normalizeHseDueDays(value, fallback = 14) {
  const n = Number(value);
  if (!Number.isInteger(n) || n < 1 || n > 365) return fallback;
  return n;
}

export function normalizeHseModuleSettings(data = {}) {
  const modules = data.modules || {};
  return {
    modules: HSE_MODULE_KEYS.reduce((memo, key) => {
      memo[key] = asBool(modules[key], true);
      return memo;
    }, {}),
    responsible_user_id: data.responsible_user_id || null,
    other_manager_user_id: data.other_manager_user_id || null,
    review_cadence_months: normalizeHseReviewCadence(data.review_cadence_months, 12),
    default_tiltak_due_days: normalizeHseDueDays(data.default_tiltak_due_days, 14),
    tiltak_require_approval: asBool(data.tiltak_require_approval, false),
  };
}

export function snapshotHseModuleSettings(data) {
  const next = normalizeHseModuleSettings(data);
  return JSON.stringify({
    modules: next.modules,
    responsible_user_id: next.responsible_user_id || null,
    other_manager_user_id: next.other_manager_user_id || null,
    review_cadence_months: next.review_cadence_months,
    default_tiltak_due_days: next.default_tiltak_due_days,
    tiltak_require_approval: next.tiltak_require_approval === true,
  });
}

export function emptyHseModuleSettings() {
  return JSON.parse(JSON.stringify(emptySettings));
}

export function toHseModuleSettingsPayload(data) {
  const next = normalizeHseModuleSettings(data);
  return {
    modules: next.modules,
    responsible_user_id: next.responsible_user_id || null,
    other_manager_user_id: next.other_manager_user_id || null,
    review_cadence_months: next.review_cadence_months,
    default_tiltak_due_days: next.default_tiltak_due_days,
    tiltak_require_approval: next.tiltak_require_approval === true,
  };
}
